import { render, staticRenderFns } from "./DwxxbgsqEdit.vue?vue&type=template&id=b798304c"
import script from "./DwxxbgsqEdit.vue?vue&type=script&lang=js"
export * from "./DwxxbgsqEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports